import { fileUrl } from '../api/client';

export const DEFAULT_BRAND_NAME = 'Global CRM';

export interface BrandProps {
  companyName?: string | null;
  /** Header text; empty = the company name */
  title?: string | null;
  subtitle?: string | null;
  logoFileId?: string | null;
  /** The browser tab icon; shown in place of the initial when the sidebar is collapsed to its icon rail */
  iconFileId?: string | null;
}

/**
 * Top of the sidebar: the workspace logo, else its initial and name, with an optional grey subtitle underneath.
 * Collapsed to the icon rail, it shows the browser tab icon when one is uploaded, else the initial.
 * Also rendered as a live preview on the settings page.
 */
export function SidebarBrand({ companyName, title, subtitle, logoFileId, iconFileId }: BrandProps) {
  const name = title?.trim() || companyName?.trim() || DEFAULT_BRAND_NAME;
  const sub = subtitle?.trim();
  const initial = name[0]?.toUpperCase();
  const className = `brand${logoFileId ? ' brand-has-logo' : ''}${iconFileId ? ' brand-has-icon' : ''}${sub ? ' brand-has-subtitle' : ''}`;
  const subtitleLine = sub ? <span className="brand-subtitle">{sub}</span> : null;
  const railIcon = iconFileId ? <img className="brand-rail-mark brand-rail-icon" src={fileUrl(iconFileId)} alt="" aria-hidden /> : null;
  if (logoFileId) {
    return (
      <div className={className}>
        {railIcon ?? (
          <span className="brand-mark brand-rail-mark" aria-hidden>
            {initial}
          </span>
        )}
        <span className="brand-text">
          <img className="brand-logo" src={fileUrl(logoFileId)} alt={name} />
          {subtitleLine}
        </span>
      </div>
    );
  }
  return (
    <div className={className}>
      <span className="brand-mark">{initial}</span>{' '}
      {railIcon}
      <span className="brand-text">
        <span className="brand-name">{name}</span>
        {subtitleLine}
      </span>
    </div>
  );
}
